import { darken } from '@savgroup-front-common/primitive/helpers/cssColor';
import { DefaultTheme } from 'styled-components';

import { getFieldColorFromStatus } from '../common/helpers/getFieldColorFromStatus';
import { InputStatus } from '../common/helpers/getFinalFieldState.types';

export const getBorderColor = ({
  theme,
  status,
  disabled,
  readOnly,
}: {
  theme: DefaultTheme;
  disabled?: boolean;
  readOnly?: boolean;
  status?: InputStatus;
}) => {
  const defaultColor = theme.colors.default;

  const fieldColorFromStatus = getFieldColorFromStatus({
    status,
    theme,
  });

  if (fieldColorFromStatus) {
    return fieldColorFromStatus;
  }

  if (disabled || readOnly) {
    return theme.colors.default;
  }

  if (!status) {
    return defaultColor;
  }

  return getFieldColorFromStatus({ status, theme }) ?? defaultColor;
};

export const getOnHoverBorderColor = ({
  theme,
  status,
  disabled,
  readOnly,
  $isFocusAndHoverBehavioursHandled,
}: {
  theme: DefaultTheme;
  disabled?: boolean;
  readOnly?: boolean;
  $isFocusAndHoverBehavioursHandled?: boolean;
  status?: InputStatus;
}) => {
  const defaultColor = theme.newUI.variationColors.light4;

  const fieldColorFromStatus = getFieldColorFromStatus({
    status,
    theme,
  });

  if (!$isFocusAndHoverBehavioursHandled) {
    return theme.colors.default;
  }

  if (fieldColorFromStatus) {
    return darken(0.1, fieldColorFromStatus);
  }

  if (disabled || readOnly) {
    return theme.colors.default;
  }

  return defaultColor;
};
